export default {
  loading: '…',
  lang: {
    en: 'English',
    de: 'Deutsch',
    ru: 'Русский',
    fr: 'Français'
  },
  nav: {
    tools: 'Инструменты',
    connect: 'Подключение',
    discord: 'Discord',
    signIn: 'Войти через Steam',
    signOut: 'Выйти'
  },
  app: {
    runTime: 'Время работы {time}',
    titleBreeder: 'rosi.wtf | Breeder',
    titleProgress: '{pct}% | GEN.{gen}'
  },
  logo: {
    plantTooltip:
      'Выберите тип растения, чтобы помнить, что скрещиваете. Выбор <strong>не влияет</strong> на результат расчёта.'
  },
  sim: {
    eyebrow: 'rosi.wtf | Breeder',
    title: 'Планировщик скрещивания',
    lead:
      'Вставьте по одной шестибуквенной строке генов на растение. Если браузер позволяет, захватите окно игры и прочитайте гены через OCR. Без установки программ.',
    calculate: 'Считать',
    stop: 'Стоп',
    skip: 'Пропуск',
    skipTooltip: 'Перейти к следующему поколению раньше (быстрее, можно потерять пути).',
    emptyTitle: 'Нет подходящих скрещиваний для этого списка',
    emptyBody: 'Добавьте растения или измените веса в настройках. С более сильными исходными генами обычно лучше.',
    browserGen2:
      'Выбранный саженец из <strong>2-го</strong> поколения. Сначала скрестите нужные саженцы. Нажимайте на <span class="simulator_highlight-guide">подсвеченные</span>, чтобы увидеть, как их получить.',
    browserGen3:
      'Выбранный саженец из <strong>3-го</strong> поколения. Сначала скрестите нужные саженцы. Нажимайте на <span class="simulator_highlight-guide">подсвеченные</span>, чтобы увидеть, как их получить.',
    browserGeoBefore: 'Расставьте растения с «E» рядом с ',
    browserGeoAfter: ' на восточных слотах грядки, а с «W» на западных, чтобы повлиять на результат скрещивания.'
  },
  gene: {
    current: 'Текущие',
    saved: 'Сохранённые',
    copied: 'Скопировано!',
    copyShare: 'Копировать ссылку',
    save: 'Сохранить',
    geneSequences: 'Последовательности генов',
    geneHint: 'Одно растение на строку: шесть букв G, H, Y, W или X.'
  },
  results: {
    labelG: 'Кол-во G',
    labelY: 'Кол-во Y',
    labelH: 'Кол-во H',
    geneN: 'Ген {n}',
    ariaIncG: 'Увеличить число G',
    ariaDecG: 'Уменьшить число G',
    ariaIncY: 'Увеличить число Y',
    ariaDecY: 'Уменьшить число Y',
    ariaIncH: 'Увеличить число H',
    ariaDecH: 'Уменьшить число H',
    conflict: 'Фильтры противоречат друг другу: {detail}',
    alreadyOwned: 'У вас уже есть этот клон под №{n} в списке',
    noResults: 'С такими фильтрами нет результатов!',
    clickCard: 'Нажмите на карточку, чтобы увидеть поколения и скрещивание!',
    pressHold: 'Удерживайте карточку, чтобы увидеть варианты.',
    showing: 'Показано {shown} из {total}. Сузьте фильтры, если список длинный.',
    ruleMinZero: 'Минимум ноль..',
    ruleMaxSix: 'Не больше шести...',
    ruleWhole: 'Должно быть целое число...'
  },
  map: {
    highlightedTitle: 'Выделенный результат',
    clearHighlight: 'Снять выделение',
    tipGeoBefore: 'Расставьте растения с «E» рядом с ',
    tipGeoAfter: ' на восточных слотах грядки, а с «W» на западных, чтобы повлиять на результат скрещивания.',
    learnMore: 'подробнее',
    tipGen2:
      'Выбранный саженец из <strong>2-го</strong> поколения. Сначала получите нужные саженцы. Нажимайте на <span class="highlighted-map_highlight-guide">подсвеченные</span>, чтобы увидеть, как их скрестить.',
    tipGen3:
      'Выбранный саженец из <strong>3-го</strong> поколения. Сначала получите нужные саженцы. Нажимайте на <span class="highlighted-map_highlight-guide">подсвеченные</span>, чтобы увидеть, как их скрестить.',
    numberHelp: '<strong>#NUMBER</strong>: позиция саженца в вашем списке генов.'
  },
  browser: {
    helperVariants: 'Здесь видны разные способы скрестить тот же саженец.',
    optionBest: 'Лучший вариант',
    optionAlt: 'Альтернативный вариант {n}'
  },
  previous: {
    empty: 'Нет сохранённых наборов генов.',
    genesCount: 'Растений: {n}'
  },
  about: {
    trigger: 'О приложении',
    title: 'О приложении',
    fork:
      '<strong>rosi.wtf | Breeder</strong>: форк старого сайта <strong>rustbreeder.com</strong>, переработанный под <a href="https://rosi.wtf" target="_blank" rel="noopener noreferrer">rosi.wtf</a>. Логика и сценарий во многом оттуда (<a href="https://github.com/wojciechSlodziak/rust-breeder" target="_blank" rel="noopener noreferrer">исходники на GitHub</a>).',
    fromOriginal: 'От автора оригинала:',
    hi: 'Привет! Надеюсь, приложение заходит :).',
    because: 'Я сделал его, потому что скрещивать каждый вайп без программы было утомительно.',
    feedback:
      'Обратная связь и помощь: мой <a href="https://discord.gg/Va5475pqFw" target="_blank" rel="noopener noreferrer">сервер Discord</a>.',
    donate:
      'Поддержать работу и расходы можно <a href="https://donorbox.org/rust-crossbreeding-optimizer?default_interval=o" target="_blank" rel="noopener noreferrer">донатом</a>.',
    fine: 'Rust Breeder не связан с Facepunch.',
    close: 'Закрыть'
  },
  options: {
    title: 'Настройки',
    reset: 'Сброс',
    tabCross: 'Скрещивание',
    tabUi: 'Интерфейс и звук',
    performance: 'Производительность',
    workers: 'Число воркеров',
    workersHint: '~65% ядер: баланс скорости и нагрузки. Выше быстрее, ниже легче для ПК.',
    breeding: 'Разведение',
    saplingsRange: 'Диапазон саженцев',
    saplingsRangeHint: '2–5 обычно хороший баланс эффективности и скорости.',
    generations: 'Поколения',
    saplingsNextGen: 'Саженцы в следующее поколение',
    saplingsNextGenHint: 'Лучшие результаты текущего поколения идут в следующий расчёт.',
    withRepetitions: 'Проверять комбинации с повторами',
    withRepetitionsHint: 'Учитывает варианты, где одно растение встречается несколько раз. Чуть медленнее.',
    geneScores: 'Веса генов',
    advanced: 'Дополнительно',
    manualMinScore: 'Мин. отслеживаемый счёт вручную',
    manualMinScoreHint: 'Меньше значение, больше памяти.',
    minimumTrackedScore: 'Минимальный отслеживаемый счёт',
    general: 'Общее',
    soundsOn: 'Звук: вкл.',
    soundsOff: 'Звук: выкл.',
    autoSaveOn: 'Автосохранение генов: вкл.',
    autoSaveOff: 'Автосохранение генов: выкл.',
    autoSaveHint: 'Если выкл., появится кнопка ручного сохранения наборов.',
    scanner: 'Сканер',
    skipGuideYes: 'Пропускать гид сканирования: да',
    skipGuideNo: 'Пропускать гид сканирования: нет',
    calibrationHeader: 'Выравнивание захвата',
    calibrationLead: 'Подстройте, если буквы не совпадают с разрешением или масштабом UI в Rust.',
    horizontalNudge: 'Сдвиг по горизонтали',
    horizontalHint: 'Сдвигает полоски захвата влево/вправо.',
    verticalNudge: 'Сдвиг по вертикали',
    verticalHint: 'Сдвигает полоски вверх/вниз.',
    geneBoxScale: 'Масштаб рамки гена',
    geneBoxHint: '1.0 по умолчанию.',
    resetAlignment: 'Сбросить выравнивание',
    close: 'Закрыть',
    set: 'Применить',
    setTooltip: 'Только для этой сессии.',
    save: 'Сохранить',
    saveTooltip: 'Применить и запомнить в браузере.',
    ariaInc: 'Увеличить',
    ariaDec: 'Уменьшить',
    genTickOne: 'одно',
    genTickTwo: 'два',
    genTickThree: 'три',
    geneScoreRule: 'Число от -1 до 1.',
    saplingsAddedRule: 'Должно быть положительным целым.',
    minTrackedRule: 'Допустимо от -6 до 6.'
  },
  scan: {
    scanRust: 'Сканировать Rust',
    stopScanning: 'Остановить скан',
    initializing: 'Инициализация…',
    dialogTitle: 'Как сканировать Rust на саженцы?',
    displayPreview: 'Предпросмотр экрана',
    close: 'Закрыть',
    scan: 'Сканировать',
    li1:
      'Лучше всего <strong>Chrome</strong>, <strong>Edge</strong> или <strong>Firefox</strong>. В других браузерах может не работать.',
    li2:
      'Проверьте <strong>USER INTERFACE SCALE</strong> = <strong>1.0</strong> в Rust. Слайдер может показывать 1.0, а значение 0.97. Команда <strong>graphics.uiscale</strong> в консоли Rust покажет фактическое значение.',
    li3:
      'Игра должна быть в <strong>16:9</strong> (1600×900, 1080p, 1440p или 4K) и в <strong>безрамочном</strong> режиме. Иначе включите оконный режим и 16:9.',
    li4: 'Нажмите <strong>SCAN</strong> и выберите окно Rust.',
    li5a: 'После начала скана покажите гены на экране:',
    li5b1: 'нажав саженец в инвентаре или хранилище,',
    li5b2: 'или посмотрев на посаженный саженец.',
    li5c: 'Каждый саженец захватывается около секунды.',
    li6: 'Удачи! Если не выходит, напишите в Discord. С активной <strong>предпросмотром</strong> проще понять, что не так.'
  },
  mapCard: {
    score: 'Очки:',
    chance: 'Шанс:',
    centerLabel: 'Центральный саженец:',
    centerAnyExtra: 'любое лишнее растение того же типа',
    tooltipCenter1:
      'Саженец, который в фазе скрещивания берёт гены от окружающих. Посадите в центр и дайте вырасти почти до 50% стадии <strong>Саженец</strong>, затем посадите вокруг остальные.',
    tooltipCenter2:
      'Это всегда <strong>дополнительное</strong> растение: если вокруг <strong>пять</strong> саженцев, всего нужно <strong>шесть</strong> растений.',
    tooltipCenter3Exact: 'Нужно посадить именно то растение, что указано; иначе скрещивание пойдёт не так.',
    tooltipCenter4Genes: 'Гены не важны. Больше G, быстрее растёт и проще закончить.',
    tooltipCenter5SameType:
      '«Тот же тип»: если жёлтая ягода, центр должен быть <strong>жёлтой ягодой</strong>; если картофель, <strong>картофельным</strong> семенем/клоном.',
    surroundingLabel: 'Окружающие саженцы:',
    tooltipSurrounding1: 'Саженцы вокруг центрального до фазы <strong>скрещивания</strong>. Все одного типа.',
    tooltipSurrounding2East: 'Расставьте их по подсказкам ВОСТОК/ЗАПАД вокруг центрального.',
    tooltipSurrounding2NoEast: 'Если центральный строго по центру грядки, расположение вокруг не важно.',
    tooltipSurrounding3:
      'Центральный достаёт по горизонтали, вертикали и диагонали. Можно использовать все восемь свободных ячеек.'
  }
};
